import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { revisione53DatiFormSelectors } from '../../../store/selectors/dati-form.selectors';
import { CoopEdilizieFormListeners } from './listeners/coop-edilizie.form-listeners';
import { CoopEdilizieFormValidators } from './validators/coop-edilizie.form-validators';
import { CoopEdilizieWarningsService } from './warnings/coop-edilizie.warnings';
import { manageSchedaDisabled, manageScObbl } from '../common/helper/scheda-settore.helper';
import { BaseRevisioneFormService } from '../../../abstracts/base-revisione-form.service';
import { DatiIdentificativiFormService } from '../../dati-identificativi/dati-identificativi-form.service';
import { formPaths } from '@shared/constants/form-paths.const';

@Injectable()
export class SchedaCoopEdilizieFormService extends BaseRevisioneFormService<CoopEdilizieWarningsService> {
    isDisabled$: Observable<boolean>;

    constructor(protected warningsService: CoopEdilizieWarningsService, protected datiIdentificativiService: DatiIdentificativiFormService) {
        super(warningsService, undefined, datiIdentificativiService);
    }

    override initListener(): void {
        new CoopEdilizieFormListeners(this._form, this.store).setListeners();
    }

    protected override initForm(): FormGroup {
        return this.fb.group(
            {
                my_SezioneI__Rilevazione: this.fb.group({
                    my_SchedaCoopEdil: this.fb.group({
                        my_ScEdilObbl: '',
                        my_CkIscrizAlbo: '',
                        my_NumPosiz: '',
                        my_CkDelibModifStat: '',
                        my_CkCopiaStatDep: '',
                        my_CkEnteConsorzio: '',
                        my_SpecConsorzio: '',
                        my_CkPresentRelaz: '',
                        my_DataRelazAnnuale: '',
                        my_DataRelazAnnualeAnnoRif: '',
                        my_CkPrescrittaQuota: '',
                        my_CkSociSotto18: '',
                        my_CkSociSubentratiGiu: '',
                        my_NaturaEnteCoop: '',
                        my_CkSociSubentratiFis: '',
                        my_CkSociSubentratiCoop: '',
                        my_CkGiuSubentratiCoop: '',
                        my_NaturaEnteSubCons: '',
                        my_CkPropDivisa: '',
                        my_SpecPropDivisa: '',
                        my_CkCoopCons: '',
                        my_CkAvviatoProgrammaRealizzazione: '',
                        my_CkMantenutaIscrSez: '',
                        my_numProgEdRealizz: '',
                        my_numAlloggiInCorsoRealiz: '',
                        my_numPrenotat: '',
                        my_CkOssPrenotAlloggi: '',
                        my_descOssPrenotAlloggi: '',
                        my_CkSociNonPrenot: '',
                        my_ruoloSociNonPrenot: '',
                        my_CkCdASociPrenOAss: '',
                        my_DescCdASociPrenOAss: '',
                        my_FonFinContiScop: '',
                        my_FonFinMutuiOrd: '',
                        my_FonFinMutuiAgev: '',
                        my_FonFinSoci: '',
                        my_FonFinAltro: '',
                        my_FonFinAltroDesc: '',
                        my_SchEdFinanzPubb: '',
                        my_SchEdAltreNotOsserv: '',
                        my_CkInCorsoProgrammaRealizzazione: '',
                        my_CkContiBancSing: '',
                        my_CkCommissSociPrenot: '',
                    }),
                }),
            },
            {
                updateOn: 'change',
                validators: CoopEdilizieFormValidators,
            }
        );
    }

    protected override afterFormInitialize(): void {
        this._manageDeactivation();
        manageScObbl(this.datiIdentificativiFormService, this._form, `${formPaths.schedaCoopEdil}.my_ScEdilObbl`);
    }

    private _manageDeactivation(): void {
        this.isDisabled$ = manageSchedaDisabled(this.store, revisione53DatiFormSelectors.getScEdilObbl);
    }
}
